const modules = import.meta.glob<string>('../assets/flags/*.webp', {
  eager: true,
  import: 'default',
  query: '?url',
});

export const flagUrls: Record<string, string> = Object.fromEntries(
  Object.entries(modules).map(([filePath, url]) => [
    filePath.split('/').pop()!.replace('.webp', '').toUpperCase(),
    url,
  ])
);
